import { render, staticRenderFns } from "./Applications.vue?vue&type=template&id=c50fb2bc&scoped=true"
import script from "./Applications.vue?vue&type=script&setup=true&lang=js"
export * from "./Applications.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Applications.vue?vue&type=style&index=0&id=c50fb2bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c50fb2bc",
  null
  
)

export default component.exports